import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Header from "@/component/header";
import { agentService } from "@/services/agent-service";
import AgentsDetails from "../../_components/agents-details";
import Footer from "@/component/footer";
import { AgentFullData } from "@/entry/server/agents";
import { Movie } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import { useQueryParams, getQueryParam } from "@/hooks/useQueryParams";
import NotFound from "@/pages-app/not-found";

export default function Page() {
    const routeParams = useParams<{ slug: string }>();
    const queryParams = useQueryParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [agentInfo, setAgentInfo] = useState<AgentFullData | null>(null);
    const [movies, setMovies] = useState<Movie[]>([]);
    const [pagination, setPagination] = useState<Pagination | null>(null);

    useEffect(function () {
        var slug = routeParams.slug;
        if (!slug) {
            setNotFound(true);
            setLoading(false);
            return;
        }

        setLoading(true);
        setNotFound(false);
        var page = getQueryParam(queryParams, "page", "1");
        if (isNaN(Number(page))) {
            page = "1";
        }

        agentService.getAgentDetails("directors", slug).then(function (agentDetails) {
            if (!agentDetails.data) {
                setNotFound(true);
                setLoading(false);
                return;
            }

            agentService.getAgentMovies("directors", slug, parseInt(page, 10)).then(function (moviesResponse) {
                if (!moviesResponse.data || !moviesResponse.pagination) {
                    setNotFound(true);
                    setLoading(false);
                    return;
                }
                setAgentInfo(agentDetails.data);
                setMovies(moviesResponse.data);
                setPagination(moviesResponse.pagination);
                setLoading(false);
            });
        });
    }, [routeParams.slug, location.search]);

    if (notFound) {
        return <NotFound />;
    }

    if (loading || !agentInfo || !pagination) {
        return (
            <div className="page-loading">
                <div className="loader" />
            </div>
        );
    }

    return (
        <>
        <Header />
        <AgentsDetails type="directors" info={agentInfo} movies={movies} pagination={pagination} />
        <Footer />
        </>
    );
}
